var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomLoans = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.214 13.6a3.213 3.213 0 0 0 3.218-3.217 3.225 3.225 0 0 0-3.218-3.217 3.225 3.225 0 0 0-3.217 3.217c-.019 1.78 1.436 3.218 3.217 3.218zM11.799 12.116a3.213 3.213 0 0 0 3.217-3.218A3.225 3.225 0 0 0 11.8 5.681a3.225 3.225 0 0 0-3.217 3.217 3.225 3.225 0 0 0 3.217 3.218z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.622 17.066H2.896a.745.745 0 0 0-.75.75v5.923c0 .42.332.751.75.751h1.726v-7.424z",
    fill: "#493B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.661 16.106a3.577 3.577 0 0 0-5.194 0l-2.297 2.39-.936.975a2.025 2.025 0 0 1-1.431.626h-4.558a.788.788 0 0 1-.778-.755c-.018-.46.336-.827.76-.827h4.629c.936 0 1.749-.699 1.908-1.655.035-.221.053-.442.053-.68 0-.442-.336-.792-.76-.792h-2.544c-.83 0-1.625-.386-2.473-.809-.884-.441-1.803-.883-2.863-.956a7.596 7.596 0 0 0-2.791.312c-.972.295-1.678 1.196-1.767 2.244h-.018v7.817h13.163c.9 0 1.749-.368 2.403-1.03l5.494-5.72c.3-.331.3-.828 0-1.14z",
    fill: "#F2AE18"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomLoans);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-loans.f97cf99a9c9fe13680683b8417297130.svg";